import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface ClientConfiguration {
  customLogo: string;
  customWebSite: string;
  customEmail: string;
  customLastNodeName: string;
  excelSingleSpreadsheet: boolean;
  bomConfigId: string;
}

interface ProjectStructure {
  name: string;
  description: string;
  img: string;
  subOptions: any;
  status: string;
  nodes: any[];
  models: any[] | null;
}

export interface Client {
  id: string;
  name: string;
  address: string | null;
  userUploaded: string | null;
  version: number;
  uploadTime: string;
  configuration: ClientConfiguration;
  projectStructure: ProjectStructure[];
}

@Injectable({
  providedIn: 'root'
})
export class AdminStateService {
  private selectedClientSubject = new BehaviorSubject<Client | null>(null);
  selectedClient$ = this.selectedClientSubject.asObservable();

  setSelectedClient(client: Client) {
    this.selectedClientSubject.next(client);
  }

  getSelectedClient(): Client | null {
    return this.selectedClientSubject.value;
  }

  clearSelectedClient() {
    this.selectedClientSubject.next(null);
  }
}
